<template>
  <button
    class="btn btn-outline-primary btn-sm d-flex align-items-center"
    type="button"
    @click="toggleDialer"
  >
    <span class="mr-50">Phone</span>
    <span
      class="erp-phone-dot"
      :class="{
        'erp-phone-dot--ready': isRegistered,
        'erp-phone-dot--busy': hasActiveCall || hasIncomingCall,
        'erp-phone-dot--error': !isRegistered,
      }"
    />
  </button>
</template>

<script>
export default {
  name: 'PhoneNavbarButton',
  computed: {
    isRegistered () {
      return this.$store.getters['phone/isRegistered']
    },
    hasActiveCall () {
      return !!this.$store.state.phone.activeCall
    },
    hasIncomingCall () {
      return !!this.$store.state.phone.incomingCall
    }
  },
  methods: {
    toggleDialer () {
      this.$store.commit('phone/SET_DIALER_VISIBLE', true)
      this.$store.dispatch('phone/persistPreferences')
    }
  }
}
</script>
